import { Headphones } from 'lucide-react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../config/appConfig';
import './PartnerAuthHeader.scss';

export const PartnerAuthHeader = ({ showCancel = false }) => (
  <header className="partner-auth-header">
    <Link className="partner-auth-header__brand" to="/" aria-label={`${APP_NAME} home`}>
      <img src="/images/logo.png" alt="" aria-hidden="true" />
      <span><strong>{APP_NAME}</strong><small>Partner</small></span>
    </Link>
    <div className="partner-auth-header__actions">
      <Link to="/contact" aria-label="Contact partner support"><Headphones size={18} /></Link>
      {showCancel && <Link className="partner-auth-header__cancel" to="/become-a-partner">Cancel</Link>}
    </div>
  </header>
);

export default PartnerAuthHeader;